import { useEffect, useState } from "react";
import axios from "../../../axios";
import { Link, useNavigate } from "react-router-dom";
import handleApiError from "../../../utils/handleApiError";
import ErrorModal from "../../components/ErrorModal";

export default function CategoryListPage() {
    const [categories, setCategories] = useState([]);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    

    const fetchCategories = async () => {
        try {
            const res = await axios.get("/admin/categories");
            setCategories(res.data);
        } catch (err) {
            setError(handleApiError(err));
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    return (
        <div >
            <div className="card mt-24">
                <div className="card-header border-bottom">
                    <h4 className="mb-4">Categories</h4>
                </div>

                <ErrorModal error={error} onClose={() => setError("")} />

                <div className="card-body">
                    <div style={{ textAlign: "right", marginBottom: "1rem" }}>
                        <Link to="/admin/categories/create">
                            <button className="btn btn-main py-9">+ Tambah Kategori</button>
                        </Link>
                    </div>

                    <table className="table table-lg table-striped w-100">
                        <thead>
                            <tr>
                                <th className="h6 text-gray-600 text-center">Nama</th>
                                <th className="h6 text-gray-600 text-center">Prefix</th>
                                <th className="h6 text-gray-600 text-center">SubKategori</th>
                            </tr>
                        </thead>
                        <tbody>
                            {categories.map((cat) => (
                                <tr
                                    key={cat.id}
                                    onClick={() => navigate(`/admin/categories/${cat.id}`)}
                                    style={{ cursor: "pointer" }}
                                    onMouseOver={(e) => e.currentTarget.style.background = "#f0f0f0"}
                                    onMouseOut={(e) => e.currentTarget.style.background = "transparent"}
                                >
                                    <td className="text-center">
                                        <span className="text-gray-600">{cat.name}</span>
                                    </td>
                                    <td className="text-center">
                                        <span className="text-gray-600">{cat.prefix}</span>
                                    </td>
                                    <td className="text-center">
                                        <span className="text-gray-600">{cat.sub_categories?.length ?? 0} →</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
